import { format, parseISO } from 'date-fns';

export const formatDate = (date: string, dateFormat = 'dd/MM/yyyy') => {
  try {
    return format(parseISO(date), dateFormat);
  } catch {
    return null;
  }
};
